
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __assign } from '../../../../../../tslib/tslib.es6.mjs.js';
import { number } from '../../../../../../style-value-types/dist/es/numbers/index.mjs.js';

var int = __assign(__assign({}, number), { transform: Math.round });

export { int };
//# sourceMappingURL=type-int.mjs.js.map
